import { render, staticRenderFns } from "./SpecialistClinic.vue?vue&type=template&id=af64ea2c&scoped=true"
import script from "./SpecialistClinic.vue?vue&type=script&lang=js"
export * from "./SpecialistClinic.vue?vue&type=script&lang=js"
import style0 from "./SpecialistClinic.vue?vue&type=style&index=0&id=af64ea2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af64ea2c",
  null
  
)

export default component.exports